module.exports = __webpack_public_path__ + "a9c2db71375a3b12e797b3b9f32acc84.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-25.png
// module id = 3102
// module chunks = 0